
    import ApiService from './ApiService.js'
    import ApiHelper from './ApiHelper.js'

    export default {
        getCompaniesByID(id) {
            let header = ApiHelper.getHeader();
            return ApiService().get('/api/companies/' + id,
                { 
                    headers: header
                });
        },
        search(value) {
            let header = ApiHelper.getHeader();
            return ApiService().get('/api/companies/0/25?search=' + value,
                { 
                    headers: header
                });
        }
    }